export default __webpack_public_path__ + "a358e0254c8bb10dc9eb56ecda616f87.png";